var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editable)?_c('text-area',{attrs:{"label":_vm.label,"labelClass":"h3","rows":10,"value":_vm.comment},on:{"input":v => _vm.$emit('update:comment', v)}}):_c('be-form-group',{attrs:{"label":_vm.label,"labelClass":"h3"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formattedComment)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }